import clsx from "clsx"
import React from "react"
import { IconProps } from "."

export default function PhoneFill({
  className,
  transform,
  ...reset
}: Readonly<IconProps>) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={clsx("h-6 w-6", className)}
      transform={transform}
      {...reset}
    >
      <path
        d="M3.9001 15.978V19.1604C3.9 19.3883 3.98632 19.6077 4.14167 19.7744C4.29701 19.9411 4.5098 20.0427 4.7371 20.0586C5.1304 20.0856 5.4517 20.1 5.7001 20.1C13.6534 20.1 20.1001 13.6533 20.1001 5.70002C20.1001 5.45162 20.0866 5.13032 20.0587 4.73702C20.0427 4.50972 19.9412 4.29693 19.7745 4.14159C19.6078 3.98625 19.3884 3.89992 19.1605 3.90002H15.9781C15.8665 3.89991 15.7588 3.9413 15.6759 4.01614C15.5931 4.09099 15.5411 4.19395 15.5299 4.30502C15.5092 4.51202 15.4903 4.67672 15.4723 4.80182C15.2934 6.05006 14.9269 7.26407 14.3851 8.40273C14.2996 8.58273 14.3554 8.79782 14.5174 8.91302L16.4596 10.3008C15.2721 13.0678 13.067 15.2729 10.3 16.4604L8.914 14.5218C8.85735 14.4426 8.77469 14.3858 8.68045 14.3613C8.58621 14.3368 8.48635 14.3462 8.3983 14.3877C7.25978 14.9285 6.04608 15.2941 4.7983 15.4722C4.6732 15.4902 4.5085 15.51 4.3033 15.5298C4.19238 15.5412 4.08964 15.5933 4.01498 15.6761C3.94032 15.759 3.89906 15.8665 3.8992 15.978H3.9001Z"
        fill="currentColor"
      />
    </svg>
  )
}
